<template>
  <app-section v-if="showComponent" :title="$t('page.dashboard.challenges')">
    <template #action>
      <view-all-button :level="1" @click="goToChallengesPage" />
    </template>
    <app-carousel
      v-slot="{ item }"
      :items="data"
      :items-per-page="itemsPerPage"
      :loop="false"
      class="challenge-carousel"
    >
      <challenge-card
        :challenge="item.challenge"
        class="challenge-card-carousel"
        @click.native="openModal(item.challenge)"
      />
    </app-carousel>
    <challenge-modal
      v-if="showModal"
      :challenge="selectedChallenge"
      :show="showModal"
      @close="showModal = false"
    />
  </app-section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { IChallenge, IJoinedChallenge } from '@rready/sdk';
import { useProductStore } from '../../store/productStore';
import { useAuthStore } from '../../store/authStore';
import challengeModal from './ChallengeModal.vue';
import challengeCard from './ChallengeCard.vue';

export default defineComponent({
  name: 'ChallengesCarouselWidget',
  components: {
    challengeModal,
    challengeCard
  },
  data() {
    return {
      loading: false,
      data: [] as IJoinedChallenge[],
      showModal: false,
      selectedChallenge: {} as IChallenge,
      itemsPerPage: 3
    };
  },
  async mounted() {
    try {
      this.data = await this.$gateway.challenge.runningChallengeList(
        this.productId
      );
      window.addEventListener('resize', this.setItemsPerPage);
      setTimeout(this.setItemsPerPage, 400);
    } catch (e) {
      console.error('Error loading challenges on dashboard', e);
      this.$toast(this.$t('error.general').toString());
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.setItemsPerPage);
  },
  computed: {
    productId(): string {
      return useProductStore().productId!;
    },
    userId(): string {
      return useAuthStore().user?.id ?? '';
    },
    showComponent(): boolean {
      return this.data.length > 0;
    }
  },
  methods: {
    openModal(challenge: IChallenge): void {
      this.selectedChallenge = challenge;
      this.showModal = true;
    },
    goToChallengesPage(): void {
      this.$router.push({
        name: 'ChallengesTab',
        params: { userId: this.userId }
      });
    },
    setItemsPerPage() {
      // we should use breakpoints for it
      const carouselElement: HTMLElement | null =
        this.$el.querySelector('.carousel');
      const carouselWidth = carouselElement?.offsetWidth || 650;
      const imageWidth = 350;
      this.itemsPerPage = Math.floor(carouselWidth / imageWidth) || 1;
    }
  }
});
</script>

<style lang="scss" scoped>
.challenge-container {
  display: flex;
  flex-direction: column;
}

.challenge-carousel {
  margin-top: calc(var(--space-4) * -1);
}

.challenge-card-carousel {
  margin: var(--space-3) 0;
  min-width: inherit;
  cursor: pointer;
}
</style>
